import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export interface RegisterUserRequest {
  company_name: string;
  contact_name: string;
  email: string;
  password: string;
  terms_accepted: boolean;
}

export async function registerUser(payload: RegisterUserRequest) {
  const { data } = await apiClient.post<unknown>(env.userRegisterPath, payload);
  return data;
}
